var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.devMode)?_c('div',{attrs:{"id":"devMode"}},[_vm._v("\n    Entorno de prueba\n  ")]):_vm._e(),_c(_vm.layout,{key:_vm.currentTimestamp,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }